import React, { useState } from 'react'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { login } from '../../lib/auth-api'
import { ConsumerForgotPasswordLink } from '../login-actions'
import Link from '@material-ui/core/Link'
import { useQueryStringParameters } from '../../lib/query-string'

const useStyles = makeStyles(theme => ({
  formField: {
    marginBottom: theme.spacing(2),
  },
}))

const formSchema = yup.object().shape({
  username: yup.string().required('This field is required'),
  password: yup.string().required('This field is required'),
})

const LoginForm = () => {
  const classes = useStyles()
  const history = useHistory()
  const { username } = useQueryStringParameters()
  const [submissionError, setSubmissionError] = useState(null)
  const { register, handleSubmit, errors, formState } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(formSchema),
  })
  const { isSubmitting } = formState

  const confirmAccountErrorLink = (username) => {
    return (
      <>
        <FormHelperText error={true}>User is not confirmed.</FormHelperText>
        <Link style={{ textAlign: 'center' }} component={RouterLink} to={`/confirm-account?username=${encodeURIComponent(username)}`}>
          Click here to confirm the account.
        </Link>
      </>
    )
  }

  const onFormSubmit = async (formValues) => {
    setSubmissionError(null)
    const { isSuccess, error } = await login(formValues.username, formValues.password)
    if (isSuccess) {
      history.push('/welcome')
    } else {
      if (error && error.type === 'UserNotConfirmedException') {
        setSubmissionError(confirmAccountErrorLink(formValues.username))
      } else {
        setSubmissionError(<FormHelperText error={true}>Username or password is incorrect. Please try again.</FormHelperText>)
      }
    }
  }

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <TextField
        className={classes.formField}
        name="username"
        label="Email"
        defaultValue={username}
        inputRef={register}
        error={!!errors.username}
        helperText={errors.username && errors.username.message}
      />
      <TextField
        name="password"
        label="Password"
        type="password"
        inputRef={register}
        error={!!errors.password}
        helperText={errors.password && errors.password.message}
      />
      <Box mt={0.5} mb={3}>
        <ConsumerForgotPasswordLink />
      </Box>
      <Button
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        type="submit"
        disabled={isSubmitting}
      >
       Log In
      </Button>
      {submissionError}
    </form>
  )
}

export default LoginForm
